/** @format */
import { ReactElement, isValidElement } from 'react';

import { GridRepeaterProps } from './index';

export const getMediaMatchedGridColumns = (
    gridColumns: Required<GridRepeaterProps>['gridColumns']
) => {
    if (typeof gridColumns === 'number') {
        return gridColumns;
    }

    const columns = gridColumns.reduce(
        (matchingColumns, { mediaQuery, columns }) => {
            if (!mediaQuery) {
                return columns;
            }

            if (typeof window === 'undefined') {
                return matchingColumns;
            }

            if (window.matchMedia(mediaQuery).matches) {
                return columns;
            }

            return matchingColumns;
        },
        0
    );

    return columns;
};

export const isFunctionComponent = <T>(
    // eslint-disable-next-line @typescript-eslint/no-explicit-any -- Legacy code: do not use as an example.
    component: any
): component is ReactElement<T> =>
    // eslint-disable-next-line @typescript-eslint/no-unsafe-argument -- Legacy code: do not use as an example.
    isValidElement<T>(component) && typeof component.type === 'function';

export const calculateRow = (
    index: number,
    gridColumns: number,
    skipRows = true
): number => {
    const row = Math.ceil((index + 1) / gridColumns);

    if (skipRows) {
        return row + (row - 1);
    }
    return row;
};

export const calculateColumn = (
    index: number,
    gridColumns: number,
    skipColumns = true
): number => {
    const column = (index % gridColumns) + 1;

    if (skipColumns) {
        return column + (column - 1);
    }
    return column;
};
